import { FC, HTMLAttributes, memo } from "react";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useQuery } from "@apollo/client";
import { FeaturedCard, Query, eonLinkAccountsGQL } from "@onmo/graphql/graphql";
import { useStyles } from "./GameCategory.style";
import ArrowWrapper from "../ArrowWrapper/ArrowWrapper";
import { FeaturedCardItem } from "./FeaturedCardItem";
import { isTV } from "../../../utils/platform";
import { getEonSteamAccount } from "../../../models/user";
import { useTranslation } from "react-i18next";
import { getLocalizedField } from "../../../models/localizedField";
import { useAppSelector } from "../../hooks";
import { selectIsAuthenticated } from "@onmo/auth";

interface IGameCategoryProps {
  section?: Query["page"]["items"][number];
  isShowVideo?: boolean;
  defaultCardWidth?: number;
  sessionTitle?: string;
  isHideRating?: boolean;
  sessionId?: string;
}

const GameCategoryComponent: FC<
  HTMLAttributes<HTMLDivElement> & IGameCategoryProps
> = (props) => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  const {
    section,
    defaultCardWidth,
    sessionTitle,
    isShowVideo,
    isHideRating,
    ...otherProps
  } = props;
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const { data: dataMe } = useQuery<{ me: Query["me"] }>(eonLinkAccountsGQL, {
    skip: !isShowVideo || !isAuthenticated,
    fetchPolicy: "cache-and-network",
  });
  const eonSteamAccount = getEonSteamAccount(
    dataMe?.me?.eonLinkedAccounts || [],
  );

  if (!section?.cards?.length) return null;

  return (
    <div {...otherProps}>
      <Typography
        variant={TypographyVariant.BodyB1Medium}
        className={classes.title}
      >
        {sessionTitle ||
          getLocalizedField(section, "title", i18n.language) ||
          section?.group}
      </Typography>
      {isTV ? (
        <div className={classes.content}>
          {section.cards.map((f) => (
            <FeaturedCardItem
              key={f.id}
              featuredCard={f as FeaturedCard}
              isShowVideo={isShowVideo}
              defaultCardWidth={defaultCardWidth}
              classes={classes}
              steamAccountStatus={eonSteamAccount?.status}
            />
          ))}
        </div>
      ) : (
        <ArrowWrapper
          className={classes.content}
          id={`content-games-${section?.group}`}
        >
          {section.cards.map((f) => (
            <FeaturedCardItem
              key={f.id}
              featuredCard={f as FeaturedCard}
              isShowVideo={isShowVideo}
              defaultCardWidth={defaultCardWidth}
              classes={classes}
              steamAccountStatus={eonSteamAccount?.status}
              isHideRating={isHideRating}
              sessionId={props.sessionId}
            />
          ))}
        </ArrowWrapper>
      )}
    </div>
  );
};

export const GameCategory = memo(GameCategoryComponent);
